import { __ACCOUNTS_URL_BASE__ } from '@@urls'
import { createSharedSelector, createSharedState } from 'preact-shared-state-hook'
import { TenantMember } from '../../../server/src/models'
import { comparing } from '../utils'

let cachedTenantId: string | undefined
const [useTenantUsers, setTenantUsers] = createSharedState<readonly TenantMember[]>()
const [useCurrentUid, setCurrentUid] = createSharedState<string | undefined>()
export const useTenantUsersWithoutCurrentUser = createSharedSelector([useTenantUsers, useCurrentUid], (tenantUsers, currentUid) =>
  tenantUsers?.filter(user => user.uid !== currentUid),
)
export const getTenantUsersWithoutCurrentUser = useTenantUsersWithoutCurrentUser.snapshot

export const loadTenantUsers = async (currentUser: { readonly uid: string }, tenantId: string | undefined) => {
  if (currentUser.uid !== useCurrentUid.snapshot()) {
    setCurrentUid(currentUser.uid)
  }
  if (tenantId === cachedTenantId) {
    return
  }
  cachedTenantId = tenantId
  setTenantUsers(undefined)
  if (!tenantId) {
    return
  }
  try {
    const response = await fetch(`${__ACCOUNTS_URL_BASE__}/api/tenants/${tenantId}/users`, { mode: 'cors', credentials: 'include' })
    if (!response.ok) {
      return
    }
    const { users } = (await response.json()) as { users: TenantMember[] }
    const tenantUsers = users
      .filter(user => user.claims?.zumeco?.permissions?.creation)
      .sort(
        comparing(
          (user: TenantMember) => user.name,
          (user: TenantMember) => user.email,
        ),
      )
    setTenantUsers(tenantUsers)
  } catch (error) {
    // todo: ユーザーが取得できなかった旨、ダイアログ上に表示する（この件で画面を開いた途端にトーストで「エラーが発生しました」だと大袈裟なので）
    console.error(error)
  }
}
